import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Icon, Tooltip } from '@b-design/fusion';
import { getQueryStringArgs } from '@/utils/url-parse';
import Requests from '@/services/request';
import { getCookie } from '@/utils';

const CategoryItem: React.FC = (props) => {
  const { value, getCategoryList, setCheckItem } = props;
  const { channelCode } = getQueryStringArgs();
  const language = getCookie('x_app_locale');

  const changeVisible = () => {
    Requests.post('/rest/intercnn/channel/category/update', {
      categoryId: value?.categoryId,
      channelCode,
      status: value.status === 'ENABLE' ? 'DISABLE' : 'ENABLE',
    }).then((res) => {
      if (res) {
        getCategoryList();
      }
    });
  };

  return (
    <div className="list-item">
      <div className="item-title" onClick={() => setCheckItem(value.id)}>
        <Icon type="draggable" size="small" />
        {/* <div
          className={classnames('item-title-name', {
            'item-title-inVisibleName': value.status === 'ENABLE' ? false : true,
          })}
        >
          {value.name}
        </div> */}
        <Tooltip
          align="b"
          v2
          trigger={
            <div
              className={classnames('item-title-name', {
                'item-title-inVisibleName': value.status === 'ENABLE' ? false : true,
              })}
            >
              {value.name}
            </div>
          }
        >
          {value.name}
        </Tooltip>
        {/* <Tag type="normal" data-tag-color="blue" data-square size="small">
          {$i18n.get({
            id: 'aopf.pages.miniAppStore.operate.setting.operational',
            dm: '运营',
          })}
        </Tag> */}
      </div>
      {value.status === 'ENABLE' ? (
        <Icon type="view--outline" size="small" onClick={changeVisible} />
      ) : (
        <Icon type="view--off--outline" size="small" onClick={changeVisible} />
      )}
    </div>
  );
};

export default CategoryItem;
